export const FolderListApi = Symbol.for('FolderListApi');
